import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import MenuWrapper from './menu-wrapper';
import MenuItem from '../components/menu-item';
import { LayoutContext } from '../contexts/layout-provider';
import { useDesignerBack } from '../hooks/use-designer-back';

/**
 * The menu used for the game designer area layouts.
 */
const GameDesignerMenu: React.FC<{ classname?: string }> = ({
  classname = ''
}) => {
  const { gameId } = useParams();
  const [mapConfig] = useLocalStorage<{ zoneId?: string }>(
    `map-config-${gameId}`,
    {}
  );
  const baseDesignerUrl = `/designer/${gameId}`;
  const layout = useContext(LayoutContext);

  const { to, label } = useDesignerBack();

  layout.setDrawerMobileMenu(
    <GameDesignerMenu classname={'app-side-nav--mobile-drawer'} />
  );

  return (
    <MenuWrapper classname={classname}>
      {/* prettier-ignore */}
      <div className={'aside-menu'}>
        <MenuItem to={to} icon={'chevron_left'} label={label} className={'text-success'} />
      </div>
      <hr />
      {/* prettier-ignore */}
      <div className={'aside-menu'}>
        <MenuItem to={`${baseDesignerUrl}/`} icon={'draw'} label={'Overview'} />
        <MenuItem to={`${baseDesignerUrl}/map/${mapConfig.zoneId ?? ""}`} icon={'map'} label={'Map'} end={false} />
        <MenuItem to={`${baseDesignerUrl}/assets/inventory`} icon={'category'} label={'Assets'} expanded={true}>
          <MenuItem to={`${baseDesignerUrl}/assets/task-content`} icon={'checklist'} label={'Task Content'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/tasks`} icon={'checklist'} label={'Tasks'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/inventory`} icon={'inventory_2'} label={'Inventory'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/titles`} icon={'military_tech'} label={'Titles'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/timers`} icon={'timer'} label={'Timers'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/zones`} icon={'activity_zone'} label={'Zone Maps'} end={false} iconSet={'outlined'} />
          <MenuItem to={`${baseDesignerUrl}/assets/areas`} icon={'flag'} label={'Areas'} end={false} iconSet={'outlined'} />
         </MenuItem>
        <MenuItem to={`${baseDesignerUrl}/resources/resource`} icon={'perm_media'} label={'Resource'} />
        <MenuItem to={`${baseDesignerUrl}/resources/theme`} icon={'palette'} label={'Theme'} />
        <MenuItem to={`${baseDesignerUrl}/resources/language`} icon={'translate'} label={'Language'} />
        <MenuItem to={`${baseDesignerUrl}/settings`} icon={'settings'} label={'Settings'} />
        <MenuItem to={`${baseDesignerUrl}/test-lab`} icon={'lab_research'} label={'Test Lab'} />
      </div>
      <hr />
      <div className={'aside-menu'}>
        <MenuItem
          to={`${baseDesignerUrl}/sales`}
          icon={'newspaper'}
          label={'Sales and Marketing'}
        />
      </div>
    </MenuWrapper>
  );
};

export default GameDesignerMenu;
